import React from "react";
import ReactSelect from "react-select";
import Datetime from "react-datetime";
import clsx from "clsx";
import MultiSelect, { Option } from '../../../_metronic/helpers/MySelect';
import Select, { components } from "react-select";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import _ from "lodash";
import { addHouseClampsDB, isVipDB, statusDB } from "./MachinesList";
import Moment from "moment";
const { Option: customOption } = components;

interface MachineProps {
  state: any;
  setState: React.Dispatch<React.SetStateAction<any>>;
  searchData: () => void;
  removeSearch: () => void;
}

const MachineFilter: React.FC<MachineProps> = ({
  state,
  setState,
  searchData,
  removeSearch,
}) => {
    const getLabelForStatus = (status: any): string => {
        switch (status) {
          case "true":
            return "Active";
          case "false":
            return "Inactive";
          case "all":
            return "All";
          default:
            return "Active";
        }
      };
      const getLabelForHasHouseClamp = (clamp: any): string => 
        clamp === "true" ? "Yes" : clamp === "false" ? "No" : "";
      
      const getLabelForIsVip = (isVip: any): string => {
        switch (isVip) {
          case "true":
            return "Yes";
          case "false":
            return "No";
          case "all":
          default:
            return "All";
        }
      };
       
  return (
    <div className="collapse" id="machine-filter" aria-labelledby="machine-filter">
          <div className="card mt-9">
            <div className="card-body w-100 p-lg-7 p-md-7 p-5">
              <div className="row mt-6">
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Apply Date filter on</label>
                  <br />
                  <label
                    className="form-check form-check-sm form-check-custom form-check-solid align-items-center fs-5 mb-1 ms-2 "
                    key="apply_date_1"
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="applyDateFilterOn"
                      value='createdAt'
                      checked={state.applyDateFilterOn === 'createdAt'}
                      onChange={() =>
                        setState({
                          applyDateFilterOn: 'createdAt'
                        })
                      }
                    />
                    <span className="form-check-label fs-5 mb-0 ms-2">
                      Created At
                    </span>
                  </label>
                  <label
                    className="form-check form-check-sm form-check-custom form-check-solid align-items-center fs-5  mb-1 ms-2"
                    key="apply_date_2"
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="applyDateFilterOn"
                      value='deploymentDate'
                      checked={state.applyDateFilterOn === 'deploymentDate'}
                      onChange={() =>
                        setState({
                          applyDateFilterOn: 'deploymentDate'
                        })
                      }
                    />
                    <span className="form-check-label fs-5 mb-0 ms-2">
                      Deployment Date
                    </span>
                  </label>
                  <label
                    className="form-check form-check-sm form-check-custom form-check-solid align-items-center fs-5  mb-1 ms-2"
                    key="apply_date_3"
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="applyDateFilterOn"
                      value='retiredAt'
                      checked={state.applyDateFilterOn === 'retiredAt'}
                      onChange={() =>
                        setState({
                          applyDateFilterOn: 'retiredAt'
                        })
                      }
                    />
                    <span className="form-check-label fs-5 mb-0 ms-2">
                      Retired At
                    </span>
                  </label>

                  <label
                    className="form-check form-check-sm form-check-custom form-check-solid align-items-center fs-5  mb-1 ms-2"
                    key="apply_date_3"
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="applyDateFilterOn"
                      value='lastBladeReplaceAt'
                      checked={state.applyDateFilterOn === 'lastBladeReplaceAt'}
                      onChange={() =>
                        setState({
                          applyDateFilterOn: 'lastBladeReplaceAt'
                        })
                      }
                    />
                    <span className="form-check-label fs-5 mb-0 ms-2">
                      Last Blade Replaced At
                    </span>
                  </label>


                  <label
                    className="form-check form-check-sm form-check-custom form-check-solid align-items-center fs-5  mb-1 ms-2"
                    key="apply_date_3"
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="applyDateFilterOn"
                      value='lastSanitizerReplacedAt'
                      checked={state.applyDateFilterOn === 'lastSanitizerReplacedAt'}
                      onChange={() =>
                        setState({
                          applyDateFilterOn: 'lastSanitizerReplacedAt'
                        })
                      }
                    />
                    <span className="form-check-label fs-5 mb-0 ms-2">
                      Last Sanitizer Replaced At
                    </span>
                  </label>

                  <label
                    className="form-check form-check-sm form-check-custom form-check-solid align-items-center fs-5  mb-1 ms-2"
                    key="apply_date_3"
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="applyDateFilterOn"
                      value='lastFilterReplacedAt'
                      checked={state.applyDateFilterOn === 'lastFilterReplacedAt'}
                      onChange={() =>
                        setState({
                          applyDateFilterOn: 'lastFilterReplacedAt'
                        })
                      }
                    />
                    <span className="form-check-label fs-5 mb-0 ms-2">
                      Last Filter Replaced At
                    </span>
                  </label>

                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">From Date</label>
                  <Datetime
                    ref={state.resetFrom}
                    closeOnSelect
                    dateFormat="YYYY-MM-DD"
                    timeFormat="HH:mm"
                    value={state.filterFromDate ? Moment(state.filterFromDate).format("YYYY-MM-DD HH:mm") : ""}
                    onChange={(e: any) => {
                      const dt = e["_d"];
                      setState({
                        filterFromDate: dt,
                      });
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">To Date</label>
                  <Datetime
                    ref={state.resetTo}
                    closeOnSelect
                    dateFormat="YYYY-MM-DD"
                    timeFormat="HH:mm"
                    value={state.filterToDate ? Moment(state.filterToDate).format("YYYY-MM-DD HH:mm") : ""}
                    onChange={(e: any) => {
                      const dt = e["_d"];
                      setState({
                        filterToDate: dt,
                      });
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Deployment Manager
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        deploymentManagerSelected: selected,
                        filterDeploymentManagerId: value,
                      });
                    }}
                    components={{
                      Option,
                    }}
                    value={state.deploymentManagerSelected}
                    options={Array.from(state.managerDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.firstName,
                        };
                      }
                    )}
                  />
                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Machine Name</label>
                  <ReactSearchAutocomplete
                    items={state.machinesDB.map((machine: any) => ({ name: machine.name, id: machine.name }))}
                    onSelect={(item: any) => {
                      setState({
                        filterName: item.name,
                      });
                    }}
                    onSearch={(keyword) => {
                      setState({
                        filterName: keyword,
                      });
                    }}
                    inputSearchString={state.filterName }
                    autoFocus
                    styling={{
                      borderRadius: '5px',
                      zIndex: 1
                    }}
                    fuseOptions={{
                      threshold: 0.2,
                    }}
                    onClear={() => {
                      setState({
                        filterName: '',
                      });
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Serial Number</label>

                  <ReactSearchAutocomplete
                    items={state.machinesDB.map((machine: any) => ({ name: machine.serialNumber, id: machine.serialNumber }))}
                    onSelect={(item: any) => {
                      setState({
                        filterSerialNumber: item.name,
                      });
                    }}
                    onSearch={(keyword) => {
                      setState({
                        filterSerialNumber: keyword,
                      });
                    }}
                    inputSearchString={state.filterSerialNumber }
                    autoFocus
                    styling={{
                      borderRadius: '5px',
                      zIndex: 1
                    }}
                    fuseOptions={{
                      threshold: 0.2,
                    }}
                    onClear={() => {
                      setState({
                        filterSerialNumber: '',
                      });
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Locations Type</label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        locationTypeSelected: selected,
                        filterLocationType: value,
                      });
                    }}
                    components={{
                      Option: customOption,
                    }}
                    value={state.locationTypeSelected}
                    options={Array.from(state.locationTypeDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: _.capitalize(_.lowerCase(value.name)),
                          description: value.description,
                        };
                      }
                    )}
                    formatOptionLabel={({ value, label, description }: any, { context, selectValue }: any) => {
                      let isChecked = false;
                      const filter = selectValue.filter((x: any) => x.value === value);
                      if (filter.length > 0) {
                        isChecked = true;
                      }
                      return context === 'menu' ? (
                        <div>
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isChecked}
                              readOnly
                            />
                            <label style={{marginLeft: '5px'}}>{label}</label>
                          </label>
                          <div className="text-muted">{description}</div>
                        </div>
                      ) : (
                        label
                      );
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Locations</label>
                  <ReactSelect
                    className="react-select"
                    placeholder=""
                    classNamePrefix="my-react-select"
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        locationSelected: selected,
                        filterLocation: value,
                      });
                    }}
                    components={{
                      Option,
                    }}
                    value={state.locationSelected}
                    options={Array.from(state.locationDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                        };
                      }
                    )}
                  />
                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Customers</label>
                  <ReactSelect
                    className="react-select"
                    placeholder=""
                    classNamePrefix="my-react-select"
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        customerSelected: selected,
                        filterCustomer: value,
                      });
                    }}
                    components={{
                      Option,
                    }}
                    value={state.customerSelected}
                    options={Array.from(state.customerDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                        };
                      }
                    )}
                  />
                </div>
                
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Region</label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        locationRegionSelected: selected,
                        filterRegionId: value,
                      });
                    }}
                    components={{
                      Option,
                    }}
                    value={state.locationRegionSelected}
                    options={Array.from(state.locationRegionDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                        };
                      }
                    )}
                  />
                </div>

                {/* <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                <label className="form-label fs-4 fw-bold">
                  Person Deploying
                </label>
                <ReactSelect
                  className="react-select"
                  classNamePrefix="my-react-select"
                  isMulti
                  placeholder=""
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  onChange={(selected: any) => {
                    const manager = selected?.map((e: any) => e.value);
                    setState({

                      managerSelected: selected,
                      filterManager: manager,
                    });
                  }}
                  components={{
                    Option,
                  }}
                  value={state.managerSelected}
                  options={Array.from(state.managerDB).map(
                    (value: any) => {
                      return {
                        value: value.id,
                        label: value.firstName,
                      };
                    }
                  )}
                />
              </div> */}


                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                  <label className="form-label fs-4  fw-bold">
                    Market Segment
                  </label>

                  <MultiSelect
                    class={clsx("react-select")}
                    title=""
                    setSelected={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);

                      setState({

                        marketSegmentIdSelected: selected,
                        filterMarketSegement: value,
                      });
                    }}
                    selected={state.marketSegmentIdSelected}
                    options={Array.from(state.marketSegmentDB).map((value: any) => {
                      return {
                        value: value.id,
                        label: value.name,
                      };
                    })}
                  />
                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Machine status
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    placeholder=""
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const value = selected?.map((e: any) => e.value);
                      setState({
                        machineStatusSelected: selected,
                        filterMachineStatus: value,
                      });
                    }}
                    components={{
                      Option: customOption,
                    }}
                    value={state.machineStatusSelected}
                    options={Array.from(state.machineStatusDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                          description: value.description,
                        };
                      }
                    )}
                    formatOptionLabel={({ value, label, description }: any, { context, selectValue }: any) => {
                      let isChecked = false;
                      const filter = selectValue.filter((x: any) => x.value === value);
                      if (filter.length > 0) {
                        isChecked = true;
                      }
                      return context === 'menu' ? (
                        <div>
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isChecked}
                              readOnly
                            />
                            <label style={{marginLeft: '5px'}}>{label}</label>
                          </label>
                          <div className="text-muted">{description}</div>
                        </div>
                      ) : (
                        label
                      );
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Blender
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    isMulti
                    placeholder=""
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const blender = selected?.map((e: any) => e.value);
                      setState({

                        blenderSelected: selected,
                        filterBlender: blender,
                      });
                    }}
                    components={{
                      Option:customOption,
                    }}
                    value={state.blenderSelected}
                    options={Array.from(state.blenderDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.title,
                          description: value.description,
                          mediaUrl: value.mediaUrl,
                        };
                      }
                    )}
                    formatOptionLabel={({ value, label, description,mediaUrl }: any, { context, selectValue }: any) => {
                      let isChecked = false;
                      const filter = selectValue.filter((x: any) => x.value === value);
                      if (filter.length > 0) {
                        isChecked = true;
                      }
                      return context === 'menu' ? (
                        <div>
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isChecked}
                              readOnly
                            />
                            <label style={{marginLeft: '5px'}}>{label}</label>
                          </label>
                          {description && (
                            <div className="text-muted">{description}</div>
                          )}
                          {mediaUrl && (
                          <div className="mt-2">
                            <img 
                              src={mediaUrl} 
                              alt={label} 
                              style={{ height:'80px',objectFit: 'cover' }} 
                            />
                          </div>
                          )}
                        </div>
                      ) : (
                        label
                      );
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Board
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    isMulti
                    placeholder=""
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const board = selected?.map((e: any) => e.value);
                      setState({
                        boardSelected: selected,
                        filterBoard: board,
                      });
                    }}
                    components={{
                      Option:customOption,
                    }}
                    value={state.boardSelected}
                    options={Array.from(state.boardDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.title,
                          description: value.description,
                          mediaUrl: value.mediaUrl,
                        };
                      }
                    )}
                    formatOptionLabel={({ value, label, description,mediaUrl }: any, { context, selectValue }: any) => {
                      let isChecked = false;
                      const filter = selectValue.filter((x: any) => x.value === value);
                      if (filter.length > 0) {
                        isChecked = true;
                      }
                      return context === 'menu' ? (
                        <div>
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isChecked}
                              readOnly
                            />
                            <label style={{marginLeft: '5px'}}>{label}</label>
                          </label>
                          {description && (
                            <div className="text-muted">{description}</div>
                          )}
                          {mediaUrl && (
                          <div className="mt-2">
                            <img 
                              src={mediaUrl} 
                              alt={label} 
                              style={{ height:'80px',objectFit: 'cover' }} 
                            />
                          </div>
                          )}
                        </div>
                      ) : (
                        label
                      );
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Site Status</label>
                  <Select
                    ref={state.resetStatus}
                    className="react-select"
                    classNamePrefix="my-react-select"
                    name="filterStatus"
                    defaultValue={{
                      label: getLabelForStatus(state.filterStatus), 
                      value: state.filterStatus 
                    }}
                    placeholder=""
                    onChange={(event: any) => {
                      setState({
                        filterStatus: event.value,
                      });
                    }}
                    options={Array.from(statusDB).map((value: any) => {
                      return {
                        value: value.id,
                        label: value.name,
                      };
                    })}
                  />
                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Mechanical hardware version</label>
                  <Select
                    ref={state.resetMechanicalHardwareVersion}
                    className="react-select"
                    classNamePrefix="my-react-select"
                    name="filterMechanicalHardwareVersion"
                    placeholder=""
                    onChange={(event: any) => {
                      setState({
                        filterMechanicalHardwareVersion: event.value,
                      });
                    }}
                    options={state.hardwareVersionsList.map((value: any) => {
                      return {
                        value: value,
                        label: value,
                      };
                    })}
                    defaultValue={[{ value: state.filterMechanicalHardwareVersion, label: state.filterMechanicalHardwareVersion  }]}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Has hose clamp?
                  </label>
                  <Select
                    ref={state.resetAddHouseClamps}
                    className="react-select"
                    classNamePrefix="my-react-select"
                    name="filterAddHouseClamps"
                    defaultValue={{
                      label: getLabelForHasHouseClamp(state.filterAddHouseClamps), 
                      value: state.filterAddHouseClamps
                    }}
                    placeholder=""
                    onChange={(event: any) => {
                      setState({
                        filterAddHouseClamps: event.value,
                      });
                    }}
                    options={Array.from(addHouseClampsDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                        };
                      }
                    )}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Cup Holder
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    isMulti
                    placeholder=""
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const cupHolder = selected?.map((e: any) => e.value);
                      setState({
                        cupHolderSelected: selected,
                        filterCupHolder: cupHolder,
                      });
                    }}
                    components={{
                      Option:customOption,
                    }}
                    value={state.cupHolderSelected}
                    options={Array.from(state.cupHolderDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.title,
                          description: value.description,
                          mediaUrl: value.mediaUrl,
                        };
                      }
                    )}
                    formatOptionLabel={({ value, label, description,mediaUrl }: any, { context, selectValue }: any) => {
                      let isChecked = false;
                      const filter = selectValue.filter((x: any) => x.value === value);
                      if (filter.length > 0) {
                        isChecked = true;
                      }
                      return context === 'menu' ? (
                        <div>
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isChecked}
                              readOnly
                            />
                            <label style={{marginLeft: '5px'}}>{label}</label>
                          </label>
                          {description && (
                            <div className="text-muted">{description}</div>
                          )}
                          {mediaUrl && (
                          <div className="mt-2">
                            <img 
                              src={mediaUrl} 
                              alt={label} 
                              style={{ height:'80px',objectFit: 'cover' }} 
                            />
                          </div>
                          )}
                        </div>
                      ) : (
                        label
                      );
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fw-bold fs-4">Is VIP</label>
                  <Select
                    ref={state.resetIsVip}
                    className="react-select"
                    classNamePrefix="my-react-select"
                    name="filterIsVip"
                    defaultValue={{
                      label: getLabelForIsVip(state.filterIsVip), 
                      value: state.filterIsVip
                    }}
                    placeholder=""
                    onChange={(event: any) => {
                      setState({
                        filterIsVip: event.value,
                      });
                    }}
                    options={Array.from(isVipDB).map((value: any) => {
                      return {
                        value: value.id,
                        label: value.name,
                      };
                    })}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fw-bold fs-4">Has polyfuses?</label>
                  <Select
                    ref={state.resetIsPolyfuses}
                    className="react-select"
                    classNamePrefix="my-react-select"
                    name="filterIsPolyfuses"
                    defaultValue={{
                      label: getLabelForIsVip(state.filterIsPolyfuses), 
                      value: state.filterIsPolyfuses
                    }}
                    placeholder=""
                    onChange={(event: any) => {
                      setState({
                        filterIsPolyfuses: event.value,
                      });
                    }}
                    options={Array.from(isVipDB).map((value: any) => {
                      return {
                        value: value.id,
                        label: value.name,
                      };
                    })}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">Mac Address</label>
                    <input
                      autoComplete="off"
                      className={clsx("form-control")}
                      name="filterMacAddress"
                      value={state.filterMacAddress}
                      onChange={(event: any) => {
                        setState({
                          filterMacAddress: event.target.value,
                        });
                      }}
                    />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Tube Shield
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    isMulti
                    placeholder=""
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const tubeShield = selected?.map((e: any) => e.value);
                      setState({
                        tubeShiledSelected: selected,
                        filterTubeShield: tubeShield,
                      });
                    }}
                    components={{
                      Option:customOption,
                    }}
                    value={state.tubeShiledSelected}
                    options={Array.from(state.tubeShieldDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                          mediaUrl: value.mediaUrl,
                          description: value.description,
                        };
                      }
                    )}
                    formatOptionLabel={({ value, label, mediaUrl,description }: any, { context, selectValue }: any) => {
                      let isChecked = false;
                      const filter = selectValue.filter((x: any) => x.value === value);
                      if (filter.length > 0) {
                        isChecked = true;
                      }
                      return context === 'menu' ? (
                        <div>
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isChecked}
                              readOnly
                            />
                            <label style={{marginLeft: '5px'}}>{label}</label>
                          </label>
                          {description && (
                            <div className="text-muted">{description}</div>
                          )}
                          {mediaUrl && (
                          <div className="mt-2">
                            <img 
                              src={mediaUrl} 
                              alt={label} 
                              style={{ height:'80px',objectFit: 'cover' }} 
                            />
                          </div>
                          )}
                        </div>
                      ) : (
                        label
                      );
                    }}
                  />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                  <label className="form-label fs-4 fw-bold">
                    Led Rings
                  </label>
                  <ReactSelect
                    className="react-select"
                    classNamePrefix="my-react-select"
                    isMulti
                    placeholder=""
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={(selected: any) => {
                      const ledRing = selected?.map((e: any) => e.value);
                      setState({
                        ledRingsSelected: selected,
                        filterLedRings: ledRing,
                      });
                    }}
                    components={{
                      Option:customOption,
                    }}
                    value={state.ledRingsSelected}
                    options={Array.from(state.ledRingsDB).map(
                      (value: any) => {
                        return {
                          value: value.id,
                          label: value.name,
                          mediaUrl: value.mediaUrl,
                          description: value.description,
                        };
                      }
                    )}
                    formatOptionLabel={({ value, label, mediaUrl,description }: any, { context, selectValue }: any) => {
                      let isChecked = false;
                      const filter = selectValue.filter((x: any) => x.value === value);
                      if (filter.length > 0) {
                        isChecked = true;
                      }
                      return context === 'menu' ? (
                        <div>
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={isChecked}
                              readOnly
                            />
                            <label style={{marginLeft: '5px'}}>{label}</label>
                          </label>
                          {description && (
                            <div className="text-muted">{description}</div>
                          )}
                          {mediaUrl && (
                          <div className="mt-2">
                            <img 
                              src={mediaUrl} 
                              alt={label} 
                              style={{ height:'80px',objectFit: 'cover' }} 
                            />
                          </div>
                          )}
                        </div>
                      ) : (
                        label
                      );
                    }}
                  />
                </div>
              </div>
              
              <div className="row">
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 ">
                  <label className="form-check form-check-custom form-check-solid me-5 d-flex mt-1 align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="filterInStock"
                      value={state.filterInStock}
                      checked={state.filterInStock}
                      onChange={(event: any) => {
                        const { checked } = event.target;
                        if (checked === true) {
                          setState({
                            filterInStock: true,
                          });
                        } else {
                          setState({
                            filterInStock: false,
                          });
                        }
                      }
                      }
                    />
                    <span
                      className="form-label fw-bold mt-3 ms-2 fs-3"
                      style={{ cursor: "pointer" }}
                    >
                      In Stock
                    </span>
                  </label>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                  <button
                    type="submit"
                    onClick={searchData}
                    className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
                  >
                    {state.addLoading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please Wait..
                        <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                      </span>
                    )}
                    {!state.addLoading && (
                      <span className="indicator-label">ADD FILTER</span>
                    )}
                  </button>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                  <button
                    type="submit"
                    onClick={removeSearch}
                    className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
                  >
                    {state.filterLoading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please Wait..
                        <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                      </span>
                    )}
                    {!state.filterLoading && (
                      <span className="indicator-label">RESET FILTER</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
  );
};

export default MachineFilter;